import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
/* MODULES DE  CONTENT */
import {HomeModule} from './home/home.module';
import {SeguridadModule} from './seguridad/seguridad.module';
import {PerfilModule} from './perfil/perfil.module';
import {LogSunatModule} from './transaccion/logSunat/logSunat.module';
import {ReporteModule} from './reporte/reporte.module';
import {LogNoTranformadosModule} from './transaccion/logNoTranformados/logNoTransformados.module';
import {LogRecibidoModule} from './transaccion/logRecibidos/logRecibido.module';
import {LogEmisorTmpModule} from './transaccion/logEmisorTmp/logEmisorTmp.module';
import {LogEmisorHistoryModule} from './transaccion/logEmisorHistory/logEmisorHistory.module';
import {ListLogSFTPModule} from "./transaccion/logSFTP/list-logSFTP.module";

@NgModule({
    imports: [
        CommonModule,
        HomeModule,
        PerfilModule,
        LogEmisorTmpModule,
        LogEmisorHistoryModule,
        LogSunatModule,
        LogNoTranformadosModule,
        LogRecibidoModule,
        SeguridadModule,
        ReporteModule,
        ListLogSFTPModule
    ],
    declarations: []
})
export class ContentModule {
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/content.module.ts